// Get the elements by ID
let one = document.getElementById("grid-one-view");
let two = document.getElementById("list-view");
let three = document.getElementById("grid-view");

// Create an object mapping the stylesheet
const stylesheets = {
  base: document.getElementById("base-stylesheet"),
  horizontal: document.getElementById("horizontal-stylesheet"),
  theme: document.getElementById("theme-stylesheet"),
};

// Function to disable/enable stylesheets based on the active stylesheet
function changeStylesheet(active) {
  // Disable all stylesheets first
  for (let key in stylesheets) {
    stylesheets[key].disabled = true;
  }

  // Enable the selected stylesheet
  if(stylesheets[active]) stylesheets[active].disabled = false;
}

// Add event listeners for the elements
one?.addEventListener("click", () => changeStylesheet("base"));
two?.addEventListener("click", () => changeStylesheet("horizontal"));
three?.addEventListener("click", () => changeStylesheet("theme"));